import type { Notification } from './notification.interface'

export const getNotificationTitle = (notification: Notification): string => {
  if (notification.type === 'agent_reply') {
    return notification.agentName
  }
  if (notification.type === 'human_message' || notification.type === 'human_note') {
    return notification.userName
  }
  if (notification.type === 'system_balance_low') {
    return notification.title
  }
  return 'Notification'
}

export const getNotificationSubtitle = (notification: Notification): string => {
  if (notification.type === 'agent_reply') {
    return `replied in ${notification.chatName}`
  }
  if (notification.type === 'human_message') {
    return `wrote in ${notification.chatName}`
  }
  if (notification.type === 'human_note') {
    return `sent a note in ${notification.chatName}`
  }
  return ''
}

export const getNotificationPreview = (notification: Notification): string => {
  if (notification.type === 'system_balance_low') {
    return notification.message
  }
  return notification.messagePreview
}
